document.getElementById('email-form').addEventListener('submit', async e => {

  e.preventDefault();
  const email = document.getElementById('email').value.trim();
  const url = 'https://p4p-api-981f37db17f6.herokuapp.com/api/v1/giveaway_tickets/all_entries';
  const container = document.getElementById('cards-container');
  container.innerHTML = ''; // clear previous results
    function formatDate(dateString) {
    // Handles "2025-09-29T00:00:00Z" or "2025-09-29"
    const [year, month, day] = dateString.split("T")[0].split("-");
    return `${month}/${day}/${year}`; // e.g. 09/29/2025
    }


  try {
    const res = await fetch(`${url}?email=${encodeURIComponent(email.toLowerCase())}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error('Network response was not ok');
    const data = await res.json();

    if (!data.length) {
      container.innerHTML = '<p class="text-center text-gray-500">No prizes found.</p>';
      return;
    }

    data.forEach(prize => {
      if (prize.total_entries === 0) return;
      // build orders HTML
      let ordersHtml = '';
      if (prize.orders && prize.orders.length) {
        ordersHtml = prize.orders.map(order => {
          const entriesList = order.entries.map(code =>
            `${code}`
          ).join(' to ');
          return `
                <div class="mt-3 p-4 bg-black rounded-lg shadow border-[1px] border-orange-500">
                  <h2 class="text-white text-2xl">Order: ${order.id}</h2>
                  <p class="text-white text-2xl">⏰ Ordered On: ${new Date(order.created_at).toLocaleString()}</p>
                  <p class="text-white text-2xl">Entry Count: ${order.entry_count}</p>
                  <p class="text-yellow-500 text-2xl font-black">🎟️ Entries: ${entriesList}</p>
                </div>`;
        }).join('');
      } else {
        ordersHtml = '<p class="text-gray-500 italic">No orders for this prize.</p>';
      }

      // drawing date display
      const drawingDate = prize.drawing_date
        ? formatDate(prize.drawing_date)
        : 'TBA';

      // render card
      const card = document.createElement('div');
      card.className = 'bg-black rounded-lg shadow p-4 md:p-6 border-[1px] border-orange-500';
      card.innerHTML = `
            <div class="flex flex-col md:flex-row items-center gap-y-4 md:gap-y-0 md:space-x-6">
              <img src="${prize.image}" alt="" class="w-full md:w-1/2 object-cover rounded"/>
              <div class="flex flex-col gap-y-2">
                <h2 class="text-5xl text-white font-black font-din">${prize.prize_title || 'Untitled Prize'}</h2>
                <p class="text-2xl text-gray-300">⏰ Drawing Date: ${drawingDate}</p>
                <p class="text-2xl text-gray-300">🎟️ Total Entries: ${prize.total_entries}</p>
                <a
                  href="https://store.punch4parkinsons.com/products/${prize.url}"
                  class="bg-yellow-500 text-black py-4 px-4 !no-underline text-center rounded-md font-black text-xl uppercase"
                >
                  Get More Entries 🎟️
                </a>
               </div>
            </div>
            <div class="mt-4 border-t pt-4">
              <h3 class="text-6xl font-black">Orders</h3>
              <span class="text-lg">
                If you already have ticket numbers from a recent drawing, don’t worry — <br>
                your total number of entries stays the same, you’ll simply receive new ticket numbers under this system.
              </span>
              ${ordersHtml}
            </div>
          `;
      container.appendChild(card);
    });
  } catch (err) {
    container.innerHTML = `<p class="text-red-500">Error: ${err.message}</p>`;
  }
});